<template>
	<p class="InlineSummary">{{ cleanedSummary }}</p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
	summary: {
		type: String,
		required: true,
	},
});

const cleanedSummary = computed(() => {
	return props.summary.replace(/&nbsp;/gi, ' ').replace(/\u00a0/g, ' ').trim();
});
</script>

<style scoped lang="scss">
	.InlineSummary {
		width: 100%;
		color: $Grey-700;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		border-left: 1px solid $Grey-300;

		@include TextStyle(BodySmallRegular);
		@include PaddingAreas(0, 0, 0, 0.25);
		@include MarginAreas(0);
	}
</style>
